$(document).ready(function(){
  $('.bpc_faq_block').click(function(){
    $(this).find('.bpc_faq_text').slideToggle();
    $(this).find('.bpc_faq_plus').toggle();
    $(this).find('.bpc_faq_min').toggle();
  });



  $('.bpc_trust_next').click(function(){
    var container = $('.bpc_trust_grid_out');
    var newScrollLeft = container.scrollLeft() + 400;
    container.animate({ scrollLeft: newScrollLeft }, 400);
  });

  $('.bpc_trust_prev').click(function(){
    var container = $('.bpc_trust_grid_out');
    var newScrollLeft = container.scrollLeft() - 400;
    container.animate({ scrollLeft: newScrollLeft }, 400);
  });

  $('.bpc_points_show_more').click(function(evt){
    evt.preventDefault();
    var getCurrentState = $(this).attr('data');
    if (getCurrentState == '1'){
      $('.bpc_points_show_more').attr('data', '0');
      $('.bpc_points_show_more').html('SHOW LESS');
      $('.hiddenMobSelection').addClass('active');
    }
    else{
       $('.bpc_points_show_more').attr('data', '1');
      $('.bpc_points_show_more').html('SHOW MORE');
      $('.hiddenMobSelection').removeClass('active');
    }

    $('html, body').animate({
        scrollTop: $(".bpc_points_container").offset().top-100
    }, 200);
  });
  
  $('.bpc_science_carousel').slick({
        infinite: false,
        slidesToShow: 2,
        initialSlide: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '200px',
        dots: true,
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0784/8358/7420/files/92676e4be1499447cee9c0894c8a7ed9.png?v=1737550841'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0784/8358/7420/files/92676e4be1499447cee9c0894c8a7ed9.png?v=1737550841'/></button>",
        responsive: [
            {
              breakpoint: 1100,
              settings: {
                centerPadding: '100px',
              }
            },
            {
              breakpoint: 768,
              settings: {
                centerPadding: '40px',
                slidesToShow: 1,
                initialSlide: 0
              }
            }
        ]
  });


  $('.arc_var_box').click(function(){
    var currentId = $(this).attr('data-id');
    $('.arc_var_box').removeClass('active');
    $(this).addClass('active');
    $('.arCf_variant[data-id="'+currentId+'"]').trigger('click');
  });
 
  
});